export const likePostTypes = {
  REQUEST: 'FEED_LIKE_POST_REQUEST',
  SUCCESS: 'FEED_LIKE_POST_SUCCESS',
  FAILED: 'FEED_LIKE_POST_FAILED',
  DELETE_REQUEST: 'DELETE_FEED_LIKE_POST_REQUEST',
  DELETE_SUCCESS: 'DELETE_FEED_LIKE_POST_SUCCESS',
  DELETE_FAILED: 'DELETE_FEED_LIKE_POST_FAILED',
};
